// extracted by mini-css-extract-plugin
export default {"buttons":"MyTask_buttons__JlnTg"};